/**
 * Alerts Page
 *
 * Full alerts dashboard with real-time SSE updates.
 * Shows alerts from the watchlist and fraud detection system.
 */

import React from 'react';
import { useSearchParams } from 'react-router-dom';
import AlertDashboard from '../components/AlertDashboard';
import '../styles/modern.css';

const AlertsPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const selectedAlertId = searchParams.get('id') || undefined;

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">

      <div className="flex-1 overflow-hidden">
        <AlertDashboard selectedAlertId={selectedAlertId} />
      </div>
    </div>
  );
};

export default AlertsPage;
